export default [{name: 'about_us',
path: '/about_us',
props: true,
component: () => import('/src/pages/about_us.vue')},
{name: 'cookies_policy',
path: '/cookies_policy',
props: true,
component: () => import('/src/pages/cookies_policy.vue')},
{name: 'customer_care',
path: '/customer_care',
props: true,
component: () => import('/src/pages/customer_care.vue')},
{name: 'delivery',
path: '/delivery',
props: true,
component: () => import('/src/pages/delivery.vue')},
{name: 'payment_methods',
path: '/payment_methods',
props: true,
component: () => import('/src/pages/payment_methods.vue')},
{name: 'privacy_policy',
path: '/privacy_policy',
props: true,
component: () => import('/src/pages/privacy_policy.vue')},
{name: 'refund_policy',
path: '/refund_policy',
props: true,
component: () => import('/src/pages/refund_policy.vue')},
{name: 'size_guide',
path: '/size_guide',
props: true,
component: () => import('/src/pages/size_guide.vue')},
{name: 'terms',
path: '/terms',
props: true,
component: () => import('/src/pages/terms.vue')},
{name: 'work_with_us',
path: '/work_with_us',
props: true,
component: () => import('/src/pages/work_with_us.vue')}];